import { css, html } from "lit";
import { ifDefined } from "lit-html/directives/if-defined.js";
import { icons, createElement } from "lucide";
import { prop } from "../../../decorators/prop/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { customIcons } from "./customIcons.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfIcon = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_name = "Info";
  }
  render() {
    if (this.dsf_size) {
      this.style.setProperty("--dsf-icon-width", this.dsf_size);
      this.style.setProperty("--dsf-icon-height", this.dsf_size);
    } else {
      this.style.removeProperty("--dsf-icon-width");
      this.style.removeProperty("--dsf-icon-height");
    }
    let iconElement;
    if (this.dsf_name in icons) {
      const lucideIcon = icons[this.dsf_name];
      iconElement = createElement(lucideIcon);
      iconElement.removeAttribute("width");
      iconElement.removeAttribute("height");
    } else if (this.dsf_name.startsWith("custom:")) {
      iconElement = customIcons[this.dsf_name];
    } else {
      iconElement = html`<img
        src=${this.dsf_name}
        onerror="this.remove()"
        alt=${ifDefined(this.dsf_accessibility_label)}
      />`;
    }
    return html`<span class="flex flex-auto" data-skeleton>${iconElement}</span>`;
  }
};
DsfIcon.shadowRootOptions = {
  ...BaseComponent.shadowRootOptions,
  delegatesFocus: false
};
DsfIcon.styles = [
  ...BaseComponent.styles,
  css`
      :host {
        display: inline-flex;
        min-width: fit-content;
        /* Default icon size */
        --dsf-icon-width: calc(2.4 * var(--dsf-base-size));
        --dsf-icon-height: calc(2.4 * var(--dsf-base-size));
        width: var(--dsf-icon-width);
        height: var(--dsf-icon-width);
      }

      svg {
        flex: 1 1 auto;
        width: auto;
        height: auto;
      }
    `
];
__decorateClass([
  prop({ type: String, reflect: true })
], DsfIcon.prototype, "dsf_name", 2);
__decorateClass([
  prop({ type: String })
], DsfIcon.prototype, "dsf_size", 2);
__decorateClass([
  prop({ type: String })
], DsfIcon.prototype, "dsf_accessibility_label", 2);
DsfIcon = __decorateClass([
  defineElement("dsf-icon")
], DsfIcon);
export {
  DsfIcon
};
